import React, { useEffect, useState, createElement } from 'react';
import { I18nProvider, useI18n } from './lib/i18n';
import { Header } from './components/Header';
import { Hero } from './components/sections/Hero';
import { Authority } from './components/sections/Authority';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { HowItWorks } from './components/sections/HowItWorks';
import { Industries } from './components/sections/Industries';
import { Trust } from './components/sections/Trust';
import { LeadForm } from './components/sections/LeadForm';
import { Footer } from './components/Footer';
import { Toast } from './components/ui/Toast';
function AppContent() {
  const {
    t
  } = useI18n();
  const [showToast, setShowToast] = useState(false);
  // SEO Meta Tags
  useEffect(() => {
    document.title = 'Emelyn De Martino | Luxury Client Advisor';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Discreet luxury sourcing and procurement coordination for aviation, yachting, residential, and hospitality.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Discreet luxury sourcing and procurement coordination for aviation, yachting, residential, and hospitality.';
      document.head.appendChild(meta);
    }
  }, []);
  // Anti-copy deterrence
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      setShowToast(true);
    };
    const handleKeyDown = (e: KeyboardEvent) => {
      // Block F12
      if (e.key === 'F12') {
        e.preventDefault();
        setShowToast(true);
        return;
      }
      // Block Ctrl/Cmd + Shift + I, J, C (DevTools shortcuts)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && ['i', 'j', 'c'].includes(e.key.toLowerCase())) {
        e.preventDefault();
        setShowToast(true);
        return;
      }
      // Block Ctrl/Cmd + A, C, S, U, P
      if ((e.ctrlKey || e.metaKey) && ['a', 'c', 's', 'u', 'p'].includes(e.key.toLowerCase())) {
        e.preventDefault();
        setShowToast(true);
      }
    };
    // Block drag events on images
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('dragstart', handleDragStart);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('dragstart', handleDragStart);
    };
  }, []);
  // Performance: preconnect to external resources
  useEffect(() => {
    const preconnects = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://images.unsplash.com'];
    preconnects.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    });
  }, []);
  return <div className="min-h-screen bg-luxury-cream text-luxury-charcoal font-body protect-content" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Authority data-id="element-4" />
        <BeforeAfter data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <Industries data-id="element-7" />
        <Trust data-id="element-8" />
        <LeadForm data-id="element-9" />
      </main>

      <Footer data-id="element-10" />

      <Toast message={t('protected')} isVisible={showToast} onClose={() => setShowToast(false)} data-id="element-11" />
    </div>;
}
export function App() {
  return <I18nProvider data-id="element-12">
      <AppContent data-id="element-13" />
    </I18nProvider>;
}